import { Container, Spinner } from "./styles";
import { createPortal } from "react-dom";
import { DEFAULT_MESSAGE } from "./utils/constants";
import useBodyScrollByPortalElements from "utils/hooks/useBodyScrollByPortalElements";
import { PORTAL_WRAPPER_ID } from "utils/constants";

const $portals = document.getElementById(PORTAL_WRAPPER_ID);
const Preloader = ({ hidden, message = DEFAULT_MESSAGE }) => {
	useBodyScrollByPortalElements({
		flag: hidden
	});
	return createPortal(
		<Container
			data-role="custom-preloader"
			className={hidden ? "hidden" : ""}
		>
			{message && <h6>{message}</h6>}
			<Spinner>
				<span></span>
			</Spinner>
		</Container>,
		$portals
	);
};

export default Preloader;
